import React, { useCallback, useState, FormEvent } from 'react';
import Input from '../../Input/Input';
import Button from '../../Button';
import { isValidPassword } from '../../../utils/validations/password';
import { useAuth } from '../../../hooks/auth';
import PasswordRules from '../../PasswordRules';
import { SignHeadText } from '../../../styles/globalStyled';

const FirstAccesSignIn: React.FC = () => {
  const [password, setPassword] = useState('');
  const { loading, handleNewPassword } = useAuth();

  const handleInputChange = useCallback(async (currentPassword) => {
    setPassword(currentPassword);
  }, []);

  const onSubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      handleNewPassword({ password });
    },
    [password, handleNewPassword],
  );

  return (
    <>
      <SignHeadText>
        <label>Para continuar, cadastre uma nova senha:</label>
        <p>Digite sua senha</p>
      </SignHeadText>
      <form onSubmit={onSubmit}>
        <Input
          name="password"
          type="password"
          placeholder="Senha"
          width="full"
          value={password}
          onChangeValue={handleInputChange}
        />
        <PasswordRules value={password} />
        <Button
          disabled={!isValidPassword(password)}
          loading={loading}
          title="Continuar"
          classType="big fat orange center topspace"
          type="submit"
        />
      </form>
    </>
  );
};

export default FirstAccesSignIn;
